export function normalizeSession(currentSession) {
  if (!currentSession?.user) {
    return null;
  }

  return {
    ...currentSession.user,
    displayName:
      currentSession.user.displayName || currentSession.user.display_name,
    applications: currentSession.applications ?? [],
  };
}
